function getResponseHeader(err, name) {
	const headers = (err && err.response && err.response.headers) || (err && err.headers) || {};
	if (headers && typeof headers.get === "function") {
		return headers.get(name);
	}
	const normalizedName = String(name || "").toLowerCase();
	const matchingKey = Object.keys(headers).find(key => String(key).toLowerCase() === normalizedName);
	return matchingKey ? headers[matchingKey] : undefined;
}

export function isStreamRateLimitError(err) {
	return Number(err && err.status) === 429
		|| Number(err && err.response && err.response.status) === 429
		|| Number(err && err.response && err.response.statusCode) === 429;
}

export function getStreamRetryDelayMs(err, {
	attempt = 0,
	now = Date.now(),
	jitterMs = Math.round(Math.random() * 250)
} = {}) {
	const retryAfterHeader = getResponseHeader(err, "retry-after");
	const retryAfterSeconds = Number(retryAfterHeader);
	let delayMs;
	let serverDirectedDelay = false;

	if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0) {
		delayMs = retryAfterSeconds * 1000;
		serverDirectedDelay = true;
	} else if (retryAfterHeader) {
		const retryAt = Date.parse(retryAfterHeader);
		if (Number.isFinite(retryAt) && retryAt > now) {
			delayMs = retryAt - now;
			serverDirectedDelay = true;
		}
	}

	if (!serverDirectedDelay) {
		const resetAtSeconds = Number(getResponseHeader(err, "x-ratelimit-reset"));
		if (Number.isFinite(resetAtSeconds) && (resetAtSeconds * 1000) > now) {
			// Stream reports this as an absolute Unix timestamp, not a duration.
			delayMs = (resetAtSeconds * 1000) - now;
			serverDirectedDelay = true;
		}
	}

	if (!serverDirectedDelay) {
		delayMs = 1200 * Math.pow(2, Math.max(0, attempt));
	}

	const delayWithJitter = Math.max(1200, delayMs) + Math.max(0, Number(jitterMs) || 0);
	// Honor Stream's full server-provided budget window. Only locally derived
	// exponential fallback waits are capped.
	return serverDirectedDelay ? delayWithJitter : Math.min(30000, delayWithJitter);
}
